var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderApp'),_c('v-content',[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('FooterApp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }